<template>
  <div class="ListingsPage">
    <div class="flex">
      <SideFilter
        class="pt-8 has-announcements:-translate-y-35 has-searchbar:md:translate-y-0 transition-transform duration-500 h-[calc(100vh-105px)] has-announcements:h-[calc(100vh-175px)] min-w-1/3 w-1/3 md:w-[290px] md:min-w-[290px] max-sm:hidden sticky overflow-y-scroll bottom-0 md:top-54 has-announcements:md:top-70 grow-0 shrink-0 pr-8 scrollbar-hover"
      />
      <section class="pt-8 grow min-w-0 sm:ml-8 mt-6 md:mt-4">
        <div
          v-if="userConfig.tradeAccountStatus === 'pending'"
          class="bg-emerald-50 text-zinc-600 py-7 px-8 rounded-2xl mb-10"
        >
          Thanks for submitting your Trade application. Our team will review it and get back to you within 2 business
          days. If you need to place an urgent order, please reach out to us at
          <a :href="`mailto:${appConfig.marketEmail}`">
            {{ appConfig.marketEmail }}
          </a>
          and we’ll do our best to fast-track your application.
        </div>
        <HeaderTitle
          :longtail="longtail"
          :competition="competition"
          :meta="meta"
          class="md:hidden"
        />
        <div class="flex-row justify-between items-center hidden md:flex">
          <div class="flex space-x-4">
            <HeaderTitle :meta="meta" :longtail="longtail" :competition="competition" />
          </div>
          <div class="flex self-start shrink-0">
            <CategorySelector />
            <PrizeCategorySelector :categories="prizeCategories(true)" />
            <SortBy />
          </div>
        </div>
        <div class="border-t mt-4"></div>
        <MobileFilter
          class="sm:border-b border-grey-light py-4 sticky"
          :prizeCategories="prizeCategories()"
          v-if="$mq === 'xs'"
        />
        <ListingPagination
          :per-page="per"
          :price-filter-applied="priceFilterApplied"
          :size-filter-applied="sizeFilterApplied"
          :guest-favourites="guestFavourites"
          class="mb-24"
        />
        <CollectionInformation class="mt-6" :filterData="filterData" />
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"

import { metaMixin } from "@/pages/ListingsPage/mixins/metaMixin"
import UrlFilterBuilder from "@/lib/Listing/UrlFilterBuilder"
import HeaderTitle from "./HeaderTitle.vue"
import SortBy from "./SortBy.vue"
import CategorySelector from "./CategorySelector.vue"
import PrizeCategorySelector from "./PrizeCategorySelector.vue"
import ListingPagination from "./ListingPagination.vue"
import MobileFilter from "./filters/mobile/MobileFilter.vue"
import SideFilter from "./filters/SideFilter.vue"
import CollectionInformation from "./CollectionInformation.vue"

export default {
  name: "ListingsPage",
  mixins: [metaMixin],
  props: ["filterData", "longtail", "competition", "guestFavourites"],
  mounted() {
    this.setUserArtist(this.userConfig.isArtist)
    const filters = UrlFilterBuilder(window.location)
    filters["longtail_id"] = this.longtail.id
    this.setConfig(this.filterData)
    this.initListings(filters)
    window.dispatchEvent(new Event("listings-page-mounted"))
  },
  methods: {
    prizeCategories(withAllOption = false) {
      const baseOptions = withAllOption ? [{ title: "Prize categories", value: "all" }] : []
      if (this.userConfig.isAdmin && this.competition.slug) return baseOptions.concat(this.prizeCategoriesMap)
      return []
    },
    ...mapActions("filter", ["setUserArtist", "initListings", "setConfig"]),
  },
  computed: {
    prizeCategoriesMap() {
      return this.competition.categories.map((category) => ({ title: category.title, value: category.id }))
    },
    priceFilterApplied() {
      return this.prices.length > 0 || this.priceRange.length > 0
    },
    sizeFilterApplied() {
      return this.sizes.length > 0 || this.width.length > 0 || this.height.length > 0
    },
    ...mapState("filter", {
      per: (state) => state.filters.per,
      prices: (state) => state.filters.prices,
      priceRange: (state) => state.filters.price_range,
      sizes: (state) => state.filters.sizes,
      width: (state) => state.filters.width,
      height: (state) => state.filters.height,
    }),
  },
  created() {
    document.querySelector("#artworks_skeleton")?.classList.add("hidden")
  },
  components: {
    HeaderTitle,
    CategorySelector,
    SortBy,
    SideFilter,
    MobileFilter,
    ListingPagination,
    CollectionInformation,
    PrizeCategorySelector,
  },
}
</script>
